import React from 'react';
import { Heart } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../lib/i18n';
export function Footer() {
  const {
    t
  } = useTranslation();
  return <footer className="py-8 px-4 text-center border-t border-[#1A1A1A]/10 bg-background" data-id="element-91">
      <div className="max-w-2xl mx-auto" data-id="element-92">
        <p className="text-text-secondary text-sm flex items-center justify-center gap-2 font-sans mb-4" data-id="element-93">
          <span data-id="element-94">© {new Date().getFullYear()} Caro Loesel</span>
          <span className="text-[#1A1A1A]/10" data-id="element-95">|</span>
          <span className="text-hotpink font-heading font-semibold" data-id="element-96">
            Official Site
          </span>
        </p>

        <div className="flex justify-center gap-4 text-xs text-text-secondary font-sans mb-4" data-id="element-97">
          <Link to="/impressum" className="hover:text-hotpink transition-colors" data-id="element-98">
            {t.footer.impressum}
          </Link>
          <span className="text-[#1A1A1A]/10" data-id="element-99">|</span>
          <Link to="/datenschutz" className="hover:text-hotpink transition-colors" data-id="element-100">
            {t.footer.datenschutz}
          </Link>
        </div>

        <div className="flex justify-center" data-id="element-101">
          <Heart className="w-4 h-4 text-hotpink/20 fill-hotpink/10" data-id="element-102" />
        </div>
      </div>
    </footer>;
}